import type {Mapper} from 'framework';
import type {AssistantMessage} from '../../domain/assistant-message';
import type {AssistantMessageDto} from '../dto/assistant.dto';
import type {AssistantAttachmentDtoToAssistantAttachmentMapper} from './assistant-attachment-dto-to-assistant-attachment.mapper';
import type {AssistantProposalDtoToAssistantProposalMapper} from './assistant-proposal-dto-to-assistant-proposal.mapper';

export class AssistantMessageDtoToAssistantMessageMapper implements Mapper<
  AssistantMessageDto,
  AssistantMessage
> {
  constructor(
    private readonly proposalMapper: AssistantProposalDtoToAssistantProposalMapper,
    private readonly attachmentMapper: AssistantAttachmentDtoToAssistantAttachmentMapper,
  ) {}

  transform(dto: AssistantMessageDto): AssistantMessage {
    return {
      id: dto.id,
      role: dto.role,
      content: dto.content,
      finishReason: dto.finishReason,
      createdAt: dto.createdAt,
      proposals: dto.proposals.map(proposal => this.proposalMapper.transform(proposal)),
      attachments: dto.attachments.map(attachment => this.attachmentMapper.transform(attachment)),
    };
  }
}
